import type {RouteRecordRaw} from 'vue-router';

import {clientBaseRoutes} from './base';
import {clientPageRoutes} from '@/app/client/router/pages';

export const clientRoutes: Array<RouteRecordRaw> = [
  ...clientBaseRoutes,
  ...clientPageRoutes,
];
